angular.module('dnecom')
    .controller('MockupListController', ["$scope", "$http", "notifications", function MockupListController($scope, $http, notifications) {
        $scope.mockups = TemplateData.value('mockups');

        $scope.tableInstance = {};

        $scope.dtInstanceCallback = function(dtInstance) {
            $scope.tableInstance = dtInstance;
        };

        $scope.searchTable = function(search) {
            $scope.tableInstance.DataTable.search(search);
            $scope.tableInstance.DataTable.draw();
        };

        $scope.dtMockupsColumnDefs = [
            {
                targets: 1,
                orderable: false
            }
        ];

        $scope.delete = function(mockup, index) {
            $http.delete(
                Routing.generate('mockup_delete', {
                    id: mockup.id
                })
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Failed to delete mockup.');
                    return;
                }

                $scope.mockups.splice(index, 1);
                notifications.success('Mockup deleted successfully.');
            }, function() {
                notifications.danger('Invalid server response.');
            });
        };
    }]);